module.exports = __webpack_public_path__ + "static/media/instructivova1.ef8682fd.png";